import type * as React from 'react';

function SvgSnooker(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <path
        d="M12 5.58974C12.9913 5.58974 13.7949 4.78615 13.7949 3.79487C13.7949 2.80359 12.9913 2 12 2C11.0087 2 10.2051 2.80359 10.2051 3.79487C10.2051 4.78615 11.0087 5.58974 12 5.58974Z"
        fill="currentColor"
      />
      <path
        d="M9.94872 9.69231C10.94 9.69231 11.7436 8.88872 11.7436 7.89744C11.7436 6.90616 10.94 6.10256 9.94872 6.10256C8.95744 6.10256 8.15385 6.90616 8.15385 7.89744C8.15385 8.88872 8.95744 9.69231 9.94872 9.69231Z"
        fill="currentColor"
      />
      <path
        d="M14.0513 9.69231C15.0426 9.69231 15.8462 8.88872 15.8462 7.89744C15.8462 6.90616 15.0426 6.10256 14.0513 6.10256C13.06 6.10256 12.2564 6.90616 12.2564 7.89744C12.2564 8.88872 13.06 9.69231 14.0513 9.69231Z"
        fill="currentColor"
      />
      <path
        d="M7.89744 13.7949C8.88872 13.7949 9.69231 12.9913 9.69231 12C9.69231 11.0087 8.88872 10.2051 7.89744 10.2051C6.90616 10.2051 6.10256 11.0087 6.10256 12C6.10256 12.9913 6.90616 13.7949 7.89744 13.7949Z"
        fill="currentColor"
      />
      <path
        d="M12 13.7949C12.9913 13.7949 13.7949 12.9913 13.7949 12C13.7949 11.0087 12.9913 10.2051 12 10.2051C11.0087 10.2051 10.2051 11.0087 10.2051 12C10.2051 12.9913 11.0087 13.7949 12 13.7949Z"
        fill="currentColor"
      />
      <path
        d="M16.1026 13.7949C17.0938 13.7949 17.8974 12.9913 17.8974 12C17.8974 11.0087 17.0938 10.2051 16.1026 10.2051C15.1113 10.2051 14.3077 11.0087 14.3077 12C14.3077 12.9913 15.1113 13.7949 16.1026 13.7949Z"
        fill="currentColor"
      />
      <path
        d="M5.84615 17.8974C6.83743 17.8974 7.64103 17.0938 7.64103 16.1026C7.64103 15.1113 6.83743 14.3077 5.84615 14.3077C4.85487 14.3077 4.05128 15.1113 4.05128 16.1026C4.05128 17.0938 4.85487 17.8974 5.84615 17.8974Z"
        fill="currentColor"
      />
      <path
        d="M9.94872 17.8974C10.94 17.8974 11.7436 17.0938 11.7436 16.1026C11.7436 15.1113 10.94 14.3077 9.94872 14.3077C8.95744 14.3077 8.15385 15.1113 8.15385 16.1026C8.15385 17.0938 8.95744 17.8974 9.94872 17.8974Z"
        fill="currentColor"
      />
      <path
        d="M14.0513 17.8974C15.0426 17.8974 15.8462 17.0938 15.8462 16.1026C15.8462 15.1113 15.0426 14.3077 14.0513 14.3077C13.06 14.3077 12.2564 15.1113 12.2564 16.1026C12.2564 17.0938 13.06 17.8974 14.0513 17.8974Z"
        fill="currentColor"
      />
      <path
        d="M18.1538 17.8974C19.1451 17.8974 19.9487 17.0938 19.9487 16.1026C19.9487 15.1113 19.1451 14.3077 18.1538 14.3077C17.1626 14.3077 16.359 15.1113 16.359 16.1026C16.359 17.0938 17.1626 17.8974 18.1538 17.8974Z"
        fill="currentColor"
      />
      <path
        d="M7.89744 22C8.88872 22 9.69231 21.1964 9.69231 20.2051C9.69231 19.2138 8.88872 18.4103 7.89744 18.4103C6.90616 18.4103 6.10256 19.2138 6.10256 20.2051C6.10256 21.1964 6.90616 22 7.89744 22Z"
        fill="currentColor"
      />
      <path
        d="M12 22C12.9913 22 13.7949 21.1964 13.7949 20.2051C13.7949 19.2138 12.9913 18.4103 12 18.4103C11.0087 18.4103 10.2051 19.2138 10.2051 20.2051C10.2051 21.1964 11.0087 22 12 22Z"
        fill="currentColor"
      />
      <path
        d="M16.1026 22C17.0938 22 17.8974 21.1964 17.8974 20.2051C17.8974 19.2138 17.0938 18.4103 16.1026 18.4103C15.1113 18.4103 14.3077 19.2138 14.3077 20.2051C14.3077 21.1964 15.1113 22 16.1026 22Z"
        fill="currentColor"
      />
      <path
        d="M20.2051 22C21.1964 22 22 21.1964 22 20.2051C22 19.2138 21.1964 18.4103 20.2051 18.4103C19.2138 18.4103 18.4103 19.2138 18.4103 20.2051C18.4103 21.1964 19.2138 22 20.2051 22Z"
        fill="currentColor"
      />
      <path
        d="M3.79487 22C4.78615 22 5.58974 21.1964 5.58974 20.2051C5.58974 19.2138 4.78615 18.4103 3.79487 18.4103C2.80359 18.4103 2 19.2138 2 20.2051C2 21.1964 2.80359 22 3.79487 22Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgSnooker;
